"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var gateway_control_1 = require("./../../features/gateway-control");
var Codec = require("./../../io/codec");
var BEES = require("./../../serialisers/byte-encoded-enum-serialiser");
var serialiser_1 = require("./../../serialisers/serialiser");
/**
 * Serialiser for {@link StatusItem}
 */
var StatusItemSerialiserClass = /** @class */ (function (_super) {
    __extends(StatusItemSerialiserClass, _super);
    function StatusItemSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link StatusItem} from the stream
     *
     * @param bis the input stream
     * @return    the {@link StatusItem} that was read
     */
    StatusItemSerialiserClass.prototype.read = function (bis) {
        var level = BEES.read(bis, gateway_control_1.StatusLevel);
        var timestamp = Codec.readInt64(bis);
        var title = Codec.readString(bis);
        var description = Codec.readString(bis);
        return {
            level: level,
            timestamp: timestamp,
            title: title,
            description: description
        };
    };
    return StatusItemSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.StatusItemSerialiserClass = StatusItemSerialiserClass;
/**
 * The {@link StatusItemSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.StatusItemSerialiser = new StatusItemSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/status-item-serialiser.js
// module id = 1282
// module chunks = 1